var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-box"}},[_c('div',{staticClass:"load-box",style:({'background': _vm.object,'width': _vm.size*20+'px','height': _vm.size*20+'px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }